import React, { Fragment, useContext, useEffect } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Button, Paper, Container } from '@material-ui/core';
import { useConfirmationStyle } from './useConfirmationStyle';
import { CheckoutContext } from '../eir-checkout/EirCheckoutContainer';

const theme = createMuiTheme({
    typography: {
        textTransform: 'none',
        textAlign: 'left',
        letterSpacing: '0px',
        fontFamily: 'gt-walsheim-regular',
        fontSize: '1rem',
        opacity: 1,
    },
    palette: {
        primary: {
            main: '#892ba0',
        },
    },
});

function EirConfirmation(props) {
    const classes = useConfirmationStyle();
    const { cartDetails } = useContext(CheckoutContext);
    useEffect(() => {
        /* to popup the qualtrics survey on confirmation page  - 
        for react pages - the code to be triggered manually
        EIRZWM-886
        */
        QSI.API.unload();
        QSI.isDebug = false;
        QSI.API.load();
        QSI.API.run();

    }, [])
    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <Container>
                    <div className={classes.eirConfirmaton}>
                        <h1 id='confirmation'>Confirmation</h1>
                        <Paper className={classes.paper}>
                            <div className='leftPadding'>
                                <img
                                    className='confirmIcon'
                                    src='/opencms/export/sites/default/.galleries/eir/icons/confirmation-tick-icon.svg'
                                />

                                <div className='confirmationContent'>
                                    <h1>Thank you for your order</h1>
                                    <p>
                                        <h4>
                                            Your order reference number is:
                                            <span className='boldFont'>
                                                {' '}
                                                {cartDetails.orderReference}{' '}
                                            </span>
                                        </h4>
                                    </p>
                                    <p>
                                        Your order has successfully been placed and you should
                                        shortly receive an email advising you of the next steps.
                                    </p>
                                    <p>
                                        {' '}
                                        If we require any additional information, a member of our
                                        team will be in touch. Thank you for choosing eir.{' '}
                                    </p>
                                    <p>
                                        If you do not receive a confirmation email, please check
                                        your spam folder.
                                    </p>
                                </div>
                                {props.feedbackUrl != '' && (
                                    <Button variant='contained' className='pupleBtn'>
                                        <a href={props.feedbackUrl} target='_blank'>
                                            Feedback
                                        </a>
                                    </Button>
                                )}
                            </div>
                        </Paper>
                    </div>
                </Container>
            </ThemeProvider>
        </Fragment>
    );
}

export default EirConfirmation;
